/**
 * Simple sidebar state management composable
 * Replacement for the tairo useSidebar composable
 */
export function useSidebar() {
  // Use useState to persist the sidebar state across components
  const isOpen = useState<boolean>('sidebar-open', () => false)

  function toggle() {
    isOpen.value = !isOpen.value
  }

  function close() {
    isOpen.value = false
  }

  function open() {
    isOpen.value = true
  }

  return {
    isOpen: readonly(isOpen),
    toggle,
    close,
    open,
  }
}
